import './footer.scss';

const Footer = () => {
    return (
        <div className="footer">
            <div className="container">
                <div className="footer__wrapper">
                    <h3>@zaemich24.com</h3>
                    <h3>Данный ресурс не является финансовым учреждением, банком или кредитором, и не несёт ответственности за любые заключенные договоры или условия. Все материалы, размещенные на сайте имееют информационный характер. Условия выдачи займов (кредитов) уточняйте на сайте МФО или банка. Данный ресурс является агрегатором финансовых инструментов и не требует наличия лицензии для ведения такой деятельности.</h3>      
                </div>
            </div>
        </div>
    )
}

export default Footer;